import {
  FaAward,
  FaBoxOpen,
  FaChartLine,
  FaCloud,
  FaCogs,
  FaCrown,
  FaGlobe,
  FaLayerGroup,
  FaRocket,
  FaServer,
  FaShoppingCart,
  FaTools,
  FaWhatsapp,
  FaWrench,
  FaCreditCard,
  FaBoxes,
  FaFileInvoice,
  FaCashRegister,
  FaChartBar
} from 'react-icons/fa';

/** Maps stored icon_key (react-icons export name) to component. */
export const PRODUCT_ICON_MAP = {
  FaRocket,
  FaChartLine,
  FaLayerGroup,
  FaCogs,
  FaGlobe,
  FaCloud,
  FaServer,
  FaAward,
  FaCrown,
  FaTools,
  FaWrench,
  FaShoppingCart,
  FaWhatsapp,
  FaCreditCard,
  FaBoxes,
  FaFileInvoice,
  FaCashRegister,
  FaChartBar,
  FaBoxOpen
};

export const PRODUCT_ICON_COLOR_TOKENS = {
  cyan: '#00e8ff',
  sky: '#38bdf8',
  violet: '#a78bfa',
  amber: '#fbbf24',
  gold: '#eab308',
  copper: '#d97706',
  silver: '#cbd5e1',
  emerald: '#34d399',
  rose: '#fb7185',
  lime: '#a3e635'
};

/** Admin picker options (icon_key values persisted in DB). */
export const PRODUCT_ICON_OPTIONS = [
  { key: 'FaRocket', labelKey: 'blogAdmin.productIconRocket' },
  { key: 'FaChartLine', labelKey: 'blogAdmin.productIconChartLine' },
  { key: 'FaLayerGroup', labelKey: 'blogAdmin.productIconLayerGroup' },
  { key: 'FaCogs', labelKey: 'blogAdmin.productIconCogs' },
  { key: 'FaGlobe', labelKey: 'blogAdmin.productIconGlobe' },
  { key: 'FaCloud', labelKey: 'blogAdmin.productIconCloud' },
  { key: 'FaServer', labelKey: 'blogAdmin.productIconServer' },
  { key: 'FaAward', labelKey: 'blogAdmin.productIconAward' },
  { key: 'FaCrown', labelKey: 'blogAdmin.productIconCrown' },
  { key: 'FaTools', labelKey: 'blogAdmin.productIconTools' },
  { key: 'FaWrench', labelKey: 'blogAdmin.productIconWrench' },
  { key: 'FaShoppingCart', labelKey: 'blogAdmin.productIconShoppingCart' },
  { key: 'FaWhatsapp', labelKey: 'blogAdmin.productIconWhatsapp' },
  { key: 'FaCreditCard', labelKey: 'blogAdmin.productIconCreditCard' },
  { key: 'FaBoxes', labelKey: 'blogAdmin.productIconBoxes' },
  { key: 'FaFileInvoice', labelKey: 'blogAdmin.productIconFileInvoice' },
  { key: 'FaCashRegister', labelKey: 'blogAdmin.productIconCashRegister' },
  { key: 'FaChartBar', labelKey: 'blogAdmin.productIconChartBar' },
  { key: 'FaBoxOpen', labelKey: 'blogAdmin.productIconBoxOpen' }
];

export const PRODUCT_ICON_COLOR_OPTIONS = [
  { key: 'cyan', labelKey: 'blogAdmin.productIconColorCyan' },
  { key: 'sky', labelKey: 'blogAdmin.productIconColorSky' },
  { key: 'violet', labelKey: 'blogAdmin.productIconColorViolet' },
  { key: 'amber', labelKey: 'blogAdmin.productIconColorAmber' },
  { key: 'gold', labelKey: 'blogAdmin.productIconColorGold' },
  { key: 'copper', labelKey: 'blogAdmin.productIconColorCopper' },
  { key: 'silver', labelKey: 'blogAdmin.productIconColorSilver' },
  { key: 'emerald', labelKey: 'blogAdmin.productIconColorEmerald' },
  { key: 'rose', labelKey: 'blogAdmin.productIconColorRose' },
  { key: 'lime', labelKey: 'blogAdmin.productIconColorLime' }
];

export function resolveProductIconColor(iconColor) {
  const raw = String(iconColor || '').trim();
  if (!raw) return PRODUCT_ICON_COLOR_TOKENS.cyan;
  if (raw.startsWith('#')) return raw;
  return PRODUCT_ICON_COLOR_TOKENS[raw] || PRODUCT_ICON_COLOR_TOKENS.cyan;
}

export function getProductIconComponent(iconKey) {
  const key = String(iconKey || '').trim();
  return PRODUCT_ICON_MAP[key] || FaBoxOpen;
}
